import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Globe, Check } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { WHATSAPP_URL } from "../../config";

export default function TopBar() {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [langOpen, setLangOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest || !e.target.closest("[data-lang-toggle]")) setLangOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const openClaim = () => {
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
  };

  const languages = [
    { code: "en", label: "English", short: "EN" },
    { code: "th", label: "\u0e44\u0e17\u0e22", short: "TH" },
    { code: "ru", label: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439", short: "RU" },
  ];
  const current = languages.find((l) => l.code === lang);

  return (
    <header
      className={`sticky top-0 z-40 transition-[background,backdrop-filter,border-color] duration-300 border-b ${
        scrolled
          ? "bg-[var(--aa-wine)]/95 backdrop-blur-md border-white/10"
          : "bg-[var(--aa-wine)] border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <img
            src="https://www.andabout.com/assets/branding/a.svg"
            alt=""
            aria-hidden="true"
            className="h-8 w-8 transition-transform group-hover:-rotate-6"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <img
            src="https://www.andabout.com/assets/branding/andabout.svg"
            alt="andabout"
            className="h-5 md:h-[22px] w-auto"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-[13px] font-medium">
          <a href="#why" className="text-[#fbf5ec]/80 hover:text-white transition-colors">{t.nav.whyAndAbout}</a>
          <a href="#audience" className="text-[#fbf5ec]/80 hover:text-white transition-colors">{t.nav.yourMarket}</a>
          <Link to="/pricing" className="text-[#fbf5ec]/80 hover:text-white transition-colors">{t.nav.plans}</Link>
        </nav>
        <div className="flex items-center gap-2">
          {/* Language toggle */}
          <div className="relative" data-lang-toggle>
            <button
              onClick={() => setLangOpen((v) => !v)}
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-[12.5px] font-medium text-[#fbf5ec] border border-white/25 hover:bg-white/10 transition-colors"
              aria-label="Change language"
            >
              <Globe className="w-3.5 h-3.5" />
              <span>{current?.short}</span>
            </button>
            {langOpen && (
              <div className="absolute right-0 mt-2 min-w-[130px] rounded-2xl bg-white border border-[var(--aa-line)] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.35)] overflow-hidden">
                {languages.map((l) => (
                  <button
                    key={l.code}
                    onClick={() => {
                      setLang(l.code);
                      setLangOpen(false);
                    }}
                    className={`w-full flex items-center justify-between px-4 py-2.5 text-[13px] text-left hover:bg-[var(--aa-cream-warm)] transition-colors ${
                      lang === l.code ? "text-[var(--aa-wine)] font-semibold" : "text-[var(--aa-ink)]"
                    }`}
                  >
                    <span>{l.label}</span>
                    {lang === l.code && <Check className="w-3.5 h-3.5" />}
                  </button>
                ))}
              </div>
            )}
          </div>
          <a
            href="#login"
            className="hidden sm:inline-flex px-4 py-2 rounded-full text-[13px] font-medium text-[#fbf5ec] border border-white/25 hover:bg-white/10 transition-colors"
          >
            {t.nav.login}
          </a>
          <Button
            onClick={openClaim}
            className="rounded-full bg-[var(--aa-cream)] text-[var(--aa-wine)] hover:bg-white font-semibold px-4 py-2 text-[13px] shadow-none"
          >
            {t.nav.claimBiz}
          </Button>
        </div>
      </div>
    </header>
  );
}
